import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  Campaign as CampaignIcon,
  Assessment as AssessmentIcon,
} from '@mui/icons-material';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config/api';

const AdminBrandSurveyTab = ({ user }) => {
  const { tokenManager } = useAuth();
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSurveys();
  }, [user]);

  const fetchSurveys = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/surveys/surveys?module=brand`, {
        headers: {
          'Authorization': `Bearer ${tokenManager.getToken()}`,
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        setSurveys(data.surveys || []);
      } else {
        toast.error('Failed to fetch brand surveys');
      }
    } catch (error) {
      console.error('Error fetching brand surveys:', error);
      toast.error('Failed to fetch brand surveys');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  const availableSurveys = surveys.filter(survey => survey.isActive);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
        {/* {isAdminView ? `${user?.firstName} ${user?.lastName}'s Brand Survey` : 'Brand Survey'} */}
      </Typography>
      
      {availableSurveys.length === 0 ? (
        <Card>
          <CardContent>
            <Box textAlign="center" py={4}>
              <CampaignIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No brand surveys available
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Brand surveys will appear here when available
              </Typography>
            </Box>
          </CardContent>
        </Card>
      ) : (
        <Grid container spacing={3}>
          {availableSurveys.map((survey) => (
            <Grid item xs={12} md={6} key={survey._id}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    {survey.title}
                  </Typography>
                  
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {survey.description}
                  </Typography>

                  <Button
                    variant="contained"
                    fullWidth
                    startIcon={<AssessmentIcon />}
                    sx={{
                      backgroundColor: 'primary.main',
                      color: 'white',
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      padding: '12px 24px',
                      borderRadius: '6px',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'primary.dark',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                        transform: 'translateY(-1px)'
                      }
                    }}
                  >
                    view survey details
                    
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default AdminBrandSurveyTab;
